// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.log-in-center {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

h1 {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-top: 4px solid #004573;
  border-bottom: 4px solid #004573;
  border-radius: 8px;
}

.vertical-line {
  height: 180px;
  width: 2px;
  background-color: #e3e3e6;
}

/* =========================================
                Contact
============================================ */

/* Contact Left */
#contact h2 {
  margin: 10px 0 20px 0;
}

#login-offices ul.office-details {
  list-style: none;
  padding: 0;
  width: 100%;
}

#login-offices ul.office-details li {
  font-family: "Open Sans", sans-serif;
  margin-top: 12px;
  display: inline-flex;
}

#login-offices ul.office-details li i {
  font-size: 20px;
  width: 45px;
}

/* =========================================
                Social Icons
============================================ */

#login-offices ul.social-list {
  padding: 0;
  margin-top: 20px;
}

#login-offices ul.social-list li {
  display: inline-block;
  padding-left: 10px;
}

#login-offices ul.social-list li a {
  text-align: center;
  border: 1px solid black;
  width: 35px;
  height: 35px;
  display: inline-block;
  line-height: 35px;
  color: black;
  border-radius: 50%;
  transition: all 400ms linear;
}

#login-offices ul.social-list li:nth-child(1) a:hover {
  background: #3b5998;
  border-color: transparent;
}

#login-offices ul.social-list li:nth-child(2) a:hover {
  background: #00aced;
  border-color: transparent;
}

#login-offices ul.social-list li:nth-child(3) a:hover {
  background: #dd4b39;
  border-color: transparent;
}
/* =========================================
                Buttons
============================================ */
.login-button {
  margin-top: 100px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/auth/LoginWithAzure.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,eAAe;EACf,6CAA6C;EAC7C,4CAA4C;EAC5C,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,yBAAyB;AAC3B;;AAEA;;8CAE8C;;AAE9C,iBAAiB;AACjB;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAGhB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;8CAE8C;;AAE9C;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAElB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;8CAE8C;AAC9C;EACE,iBAAiB;AACnB","sourcesContent":[".log-in-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n\nh1 {\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  border-top: 4px solid #004573;\n  border-bottom: 4px solid #004573;\n  border-radius: 8px;\n}\n\n.vertical-line {\n  height: 180px;\n  width: 2px;\n  background-color: #e3e3e6;\n}\n\n/* =========================================\n                Contact\n============================================ */\n\n/* Contact Left */\n#contact h2 {\n  margin: 10px 0 20px 0;\n}\n\n#login-offices ul.office-details {\n  list-style: none;\n  padding: 0;\n  width: 100%;\n}\n\n#login-offices ul.office-details li {\n  font-family: \"Open Sans\", sans-serif;\n  margin-top: 12px;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n#login-offices ul.office-details li i {\n  font-size: 20px;\n  width: 45px;\n}\n\n/* =========================================\n                Social Icons\n============================================ */\n\n#login-offices ul.social-list {\n  padding: 0;\n  margin-top: 20px;\n}\n\n#login-offices ul.social-list li {\n  display: inline-block;\n  padding-left: 10px;\n}\n\n#login-offices ul.social-list li a {\n  text-align: center;\n  border: 1px solid black;\n  width: 35px;\n  height: 35px;\n  display: inline-block;\n  line-height: 35px;\n  color: black;\n  border-radius: 50%;\n  -webkit-transition: all 400ms linear;\n  transition: all 400ms linear;\n}\n\n#login-offices ul.social-list li:nth-child(1) a:hover {\n  background: #3b5998;\n  border-color: transparent;\n}\n\n#login-offices ul.social-list li:nth-child(2) a:hover {\n  background: #00aced;\n  border-color: transparent;\n}\n\n#login-offices ul.social-list li:nth-child(3) a:hover {\n  background: #dd4b39;\n  border-color: transparent;\n}\n/* =========================================\n                Buttons\n============================================ */\n.login-button {\n  margin-top: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
